import { api } from '@/services'

async function generateAppointmentReport (params) {
  return await api.post('/web/report/appointment', params, { responseType: 'arraybuffer' })
}

export { generateAppointmentReport }
